import axios from "axios";

// Ensure BASE_URL is correctly retrieved from environment variables
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchServices = async () => {
  try {
    // Retrieve lang value from localStorage
    const lang = localStorage.getItem("lang") || "ru"; // Default to "ru" if not found

    const response = await axios.get(`${BASE_URL}/api/service`, {
      params: { lang }, // Append lang as a query parameter
      headers: {
        "Content-Type": "application/json",
      },
    });

    // console.log("RESPONSEEEEE",lang);
    return response.data;
    
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};
